window.SB = window.SB || {};

window.SB.TrackingResult = (function () {
  const klass = function () {
    this.internal_buffer = {};
  };
  klass.prototype = {
    isChanged(key, value) {
      const changed = this.internal_buffer[key] !== value;
      // eslint-disable-next-line no-prototype-builtins
      const result = this.internal_buffer.hasOwnProperty(key) ? changed : true;
      this.internal_buffer[key] = value;
      return result;
    },
  };

  return klass;
})();
